var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDateFilterIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.929688,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#3C3ADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0124 10.2772H21.4383M23.0124 14.9994H19.0772M23.0124 19.7216H19.0772M11.9939 21.2957V16.2281C11.9939 16.0644 11.9939 15.9826 11.9778 15.9043C11.9635 15.8349 11.9399 15.7676 11.9077 15.7044C11.8713 15.6333 11.8202 15.5694 11.7179 15.4415L9.12165 12.1962C9.01937 12.0684 8.96824 12.0044 8.93187 11.9333C8.89961 11.8701 8.87603 11.8029 8.86177 11.7334C8.8457 11.6551 8.8457 11.5733 8.8457 11.4095V9.96238C8.8457 9.5216 8.8457 9.30121 8.93148 9.13286C9.00694 8.98477 9.12734 8.86437 9.27543 8.7889C9.44379 8.70313 9.66418 8.70312 10.105 8.70312H17.0309C17.4717 8.70312 17.6921 8.70313 17.8604 8.7889C18.0085 8.86437 18.1289 8.98477 18.2044 9.13286C18.2901 9.30121 18.2901 9.5216 18.2901 9.96238V11.4095C18.2901 11.5733 18.2901 11.6551 18.2741 11.7334C18.2598 11.8029 18.2362 11.8701 18.204 11.9333C18.1676 12.0044 18.1164 12.0684 18.0142 12.1962L15.4179 15.4415C15.3157 15.5694 15.2645 15.6333 15.2282 15.7044C15.1959 15.7676 15.1723 15.8349 15.1581 15.9043C15.142 15.9826 15.142 16.0644 15.142 16.2281V18.9346L11.9939 21.2957Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDateFilterIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DateFilterIcon.885924bd.svg";
export { ForwardRef as ReactComponent };